import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as ROUTES from 'config/routes';
import { PageContainer } from '@/smart-components';
import { PageContent } from 'components';
import { userIsAuthenticatedRedir } from 'hocs/auth';
import NotificationsList from './notifications-list';
import NotificationsForm from './notifications-form';
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs';
import { Icon, Typography } from '@/elements';

import './index.scss';
const { Title } = Typography;

const menus = [
	{
		name: 'add-notification',
		key: 'add-notification',
		label: 'Create a notification',
	},
];
class NotificationsContainer extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		const { clientId,logUserTab } = this.props;
		const tab = "Notifications"
    	logUserTab({ clientId, tab})
	}

	render() {
		return (
			<PageContainer>
				<PageContent className="notifications-content">
					<PageContent.Main>
						<Switch>
							<Route
								exact
								path={ROUTES.NOTIFICATIONS}
								component={NotificationsList}
							/>
							<Route
								exact
								path={ROUTES.NOTIFICATIONS_EDIT}
								component={NotificationsForm}
							/>
							<Route
								exact
								path={ROUTES.NOTIFICATIONS_ADD}
								component={NotificationsForm}
							/>
						</Switch>
					</PageContent.Main>
				</PageContent>
			</PageContainer>
		);
	}
}

export const actions = {
	logUserTab
  }
  
export default compose(
	userIsAuthenticatedRedir,
	withClientId,
	connect(null, actions)
)(NotificationsContainer);



// WEBPACK FOOTER //
// ./src/pages/notifications/index.js